export default __webpack_public_path__ + "static/media/open.45f55245.svg";